import { render, staticRenderFns } from "./EmailBroadcastEditorHeader.vue?vue&type=template&id=0322b406&scoped=true"
import script from "./EmailBroadcastEditorHeader.vue?vue&type=script&lang=js"
export * from "./EmailBroadcastEditorHeader.vue?vue&type=script&lang=js"
import style0 from "./EmailBroadcastEditorHeader.vue?vue&type=style&index=0&id=0322b406&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0322b406",
  null
  
)

export default component.exports